var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "portal-filter-bar", attrs: { "aria-label": _vm.label } },
    [
      _c("div", { staticClass: "filter-controls" }, [_vm._t("default")], 2),
      _vm.$slots.summary || _vm.$scopedSlots.summary
        ? _c("div", { staticClass: "filter-summary" }, [_vm._t("summary")], 2)
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }